import { Component, OnInit, ViewChild, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { LocalDataSource } from 'ng2-smart-table';
import { AttachedDocumentConfig } from './shared/attached-document-exp.config.service';
import { AttachedDocumentDataService } from './shared/attached-document-exp.data.service';
import { ConfirmComponent, DocumentoAnexo, Tramite } from '@app/shared';
import { findIndex } from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-attached-document-exp',
  templateUrl: './attached-document-exp.component.html',
  styleUrls: ['./attached-document-exp.component.scss'],
  providers: [AttachedDocumentDataService]
})
export class AttachedDocumentExpedientComponent implements OnInit, OnDestroy {

  // tramite actual
  @Input() tramite: any;
  // Oculta o muestra el boton de regresar
  @Input() single = true;
  // Oculta o muestra el titulo del componente
  @Input() title: Boolean = true;
  // Define las extensiones de los archivos permitidos
  @Input() extensions: Array<string> = ['.jpg', '.png', '.pdf', '.xlsx', '.xls', '.docx', '.tiff', '.tif', '.doc'];
  // Mensaje de guardar componente
  messaggeLoading = '';
  // Label de las extensiones permitidas
  extensionsLabel = '';
  extensionsText = '';
  // Controla el evento de carga
  loadingProcess = false;
  // Contiene los archivos subidos
  attachedDocuments: DocumentoAnexo[] = [];
  // Configuracion de la tabla de visualizacion de los archivos subidos
  settings = {};
  // Datos para llenar la tabla
  source: LocalDataSource;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Evento que emite al presionar el boton de regresar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // Referencia del componente fileupload
  @ViewChild('fileUploadExp') private fileUpload: FileUpload;
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) private confirmRef: ConfirmComponent;

  constructor(private adds: AttachedDocumentDataService) { }

  ngOnInit() {
    for (let i = 0; i < this.extensions.length; i++) {
      this.extensionsLabel += this.extensions[i];
      this.extensionsText += this.extensions[i];
      if (i !== (this.extensions.length - 1)) {
        this.extensionsLabel += ', ';
        this.extensionsText += ',';
        this.extensionsText += this.extensions[i].toUpperCase();
        this.extensionsText += ',';
      }
    }
    const docsC = new AttachedDocumentConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.accionTable(data.action, data.value);
    });
    if (this.tramite) {
      this.adds.getAttachedDocument(this.tramite).subscribe((documents: any[]) => {
        if (documents.length) {
          documents.map(document => {
            if (document.fecha_registro) {
              const date = new Date(document.fecha_registro);
              document.fecha_registro = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
            }
            document['finish'] =  false;
          });
        }
        this.attachedDocuments = documents;
        this.source = new LocalDataSource(this.attachedDocuments);
      });
    } else {
      this.source = new LocalDataSource(this.attachedDocuments);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla las acciones en la tabla
   *
   * @param {string} action
   * @param {*} data
   * @memberof AttachedDocumentExpedientComponent
   */
  accionTable(action: string, data: any) {
    switch (action) {
      case 'eliminar':
        this.deleteDocumentAttached(data);
        break;
      default:
        this.dowmloadDocumentAttached(data);
        break;
    }
  }

  /**
   * Se encarga de subir los documentos cargados
   *
   * @param {*} event
   * @memberof AttachedDocumentExpedientComponent
   */
  onUpload(event: any) {
    const formData = new FormData();
    const nameDocument: string[] = [];
    if (event.files) {
      this.messaggeLoading = 'Procesando documentos';
      this.loadingProcess = true;
      formData.append('id_tramite', String(this.tramite));
      for (const file of event.files) {
        formData.append(file.name, file);
        nameDocument.push(file.name);
      }
      formData.append('documentos', JSON.stringify(nameDocument));
      this.messaggeLoading = 'Subiendo documentos';
      this.adds.addAttachedDocument(formData).then(resp => {
        this.fileUpload.clear();
        if (resp && resp.length) {
          resp.forEach(document => {
            if (document.fecha_registro) {
              const date = new Date(document.fecha_registro);
              document.fecha_registro = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
            }
            document['finish'] = false;
            this.attachedDocuments.push(document);
          });
        }
        this.source.refresh();
        this.loadingProcess = false;
        this.messaggeLoading = '';
      }).catch(_err => {
        this.loadingProcess = false;
        this.messaggeLoading = '';
      });
    }
  }

  /**
   * Emite el evento de regresar
   *
   * @returns {*}
   * @memberof AttachedDocumentExpedientComponent
   */
  closeComponent(): any {
    this.close.emit(true);
  }

  /**
   * Elimina el documento anexado seleccionado
   *
   * @private
   * @param {*} data
   * @memberof AttachedDocumentExpedientComponent
   */
  private deleteDocumentAttached(data: any) {
    this.confirmRef.new({
      question: '¿Realmente desea eliminar el archivo anexado?',
      labelConfirm: 'Sí',
      labelDecline: 'No'
    }).then(resp => {
      if (resp) {
        if (data['id']) {
          this.messaggeLoading = 'Eliminando archivo';
          this.loadingProcess = true;
          this.adds.deleteAttachedDocument(data['id']).then(respon => {
            if (respon) {
              const index = findIndex(this.attachedDocuments, {id: data['id']});
              if (index !== -1) {
                this.attachedDocuments.splice(index, 1);
                this.source = new LocalDataSource(this.attachedDocuments);
                this.source.refresh();
              }
            }
            this.loadingProcess = false;
            this.messaggeLoading = '';
          }).catch(_err => {
            this.loadingProcess = false;
            this.messaggeLoading = '';
          });
        }
      }
    });
  }

  /**
   * Descargar documento anexado seleccionado
   *
   * @private
   * @param {*} data
   * @memberof AttachedDocumentExpedientComponent
   */
  private dowmloadDocumentAttached(data: any) {
    this.adds.getDownloadAttachedDocument(data['id']).subscribe(res => {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.target = '_blank';
      a.href = res.path;
      a.download = res.name;
      a.click();
      window.URL.revokeObjectURL(res.path);
      a.remove();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/attached-document-exp/attached-document-exp.component.ts